export default __webpack_public_path__ + "static/media/tutor-login.ace0809d.png";